<template>
<div class="chapter">
<div class="inner_page">
<div class="fm">
<h2 class="fmtitle"><span class="bold">Dedication</span></h2>
<p class="noindent"><em class="italic">I would like to dedicate this book to my wonderful late mum, Lucy, who taught me to crochet and knit and whose love of flowers was the inspiration for this book. Also to my amazing partner, Dave, for his constant love, support and for happily living under a mountain of yarn.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?0d71af4a